import { render } from "./TransactionDetailsView.vue?vue&type=template&id=0118f083&ts=true"
import script from "./TransactionDetailsView.vue?vue&type=script&lang=ts"
export * from "./TransactionDetailsView.vue?vue&type=script&lang=ts"

import "./TransactionDetailsView.vue?vue&type=style&index=0&id=0118f083&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TransactionDetailsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0118f083"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0118f083', __exports__)) {
    api.reload('0118f083', __exports__)
  }
  
  module.hot.accept("./TransactionDetailsView.vue?vue&type=template&id=0118f083&ts=true", () => {
    api.rerender('0118f083', render)
  })

}


export default __exports__